import { render, staticRenderFns } from "./privacy-protocol.vue?vue&type=template&id=ad427a78&"
import script from "./privacy-protocol.vue?vue&type=script&lang=js&"
export * from "./privacy-protocol.vue?vue&type=script&lang=js&"
import style0 from "./privacy-protocol.vue?vue&type=style&index=0&id=ad427a78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports